export default "__VITE_ASSET__241d1216__"